import * as React from "react";
import { SVGProps } from "react";

const CloseCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || 16}
    height={props.height || 16}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.7494 13.75L7.75 7.75M7.75064 13.75L13.75 7.75"
      stroke={props.fill || "#DA291C"}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.75 10.75C20.75 5.22715 16.2728 0.75 10.75 0.75C5.22715 0.75 0.75 5.22715 0.75 10.75C0.75 16.2728 5.22715 20.75 10.75 20.75C16.2728 20.75 20.75 16.2728 20.75 10.75Z"
      stroke={props.fill || "#DA291C"}
      stroke-width="1.5"
    />
  </svg>
);

export default CloseCircle;
